"use client";

import React, { useContext } from "react";
import { useRouter } from "next/navigation";
import classNames from "classnames";
import { HeroProps } from "./types";
import { Button as ButtonLib } from "@npm_leadtech/qr-ui-components";
import { Typography } from "../Typography";
import { AmplitudeContext } from "@/contexts/AmplitudeContext/AmplitudeContext";

import { NextImage } from "../NextImage";
import { paths } from "@/utils/paths";
import "./styles.scss";

export const Hero = ({
  heroText,
  cta,
  img,
  reverse,
  className,
  children,
  twoColumns,
  priority,
}: HeroProps) => {
  const classnames = classNames(`Hero__container`, {
    [`Hero__container--reverse`]: reverse,
    [`Hero__container--${className}`]: className,
    [`Hero__container--twoColumns`]: twoColumns,
  });
  const router = useRouter();

  const { setSource } = useContext(AmplitudeContext);

  const handleHeroClick = () => {
    setSource("cta_hero_banner");
    router.push(paths.qrEditor());
  };

  return (
    <div
      className={classnames}
      data-testid="Hero">
      <div className={`Hero__column ${twoColumns ? "Hero__column--left" : ""}`}>
        {heroText?.map((item, i: number) => (
          <Typography
            key={i}
            Tag={item.tag}
            size={item.size}
            classname={item.classname}
            spacing={item.spacing}>
            {item.list
              ? item.list.map((e, i) => (
                  <li key={i}>{<span dangerouslySetInnerHTML={{ __html: e["item"] }}></span>}</li>
                ))
              : item.content}
          </Typography>
        ))}

        {cta && (
          <div className="buttonWrapper cta-hero-banner-btn">
            <ButtonLib
              dataQA={cta.data_qa}
              onClick={handleHeroClick}
              label={cta.ctaLabel}
              variant="secondary"
            />
          </div>
        )}
      </div>

      {twoColumns && (
        <div className="Hero__column--right">
          {img && (
            <NextImage
              src={img}
              alt="qr grid selection"
              className="hero-img"
              width={633}
              height={379}
              priority={priority}
            />
          )}
          {cta && (
            <div className="buttonWrapper cta-mobile">
              <ButtonLib
                dataQA={cta.data_qa}
                onClick={handleHeroClick}
                label={cta.ctaLabel}
                variant="secondary"
              />
            </div>
          )}
        </div>
      )}
      {children}
    </div>
  );
};
